





















import { defineComponent } from '@vue/composition-api';
import ElRadioGroup     from 'element-ui/lib/radio-group';

export default defineComponent({
  name: 'cRadioGroup',
  components: {
    ElRadioGroup,
  },
});
